import angular from 'angular';
import fitTextDirective from './fitTextDirective';

angular.module('sh.fitText', []).directive('shFitText', fitTextDirective);
